import { render, staticRenderFns } from "./ButtonOptions.vue?vue&type=template&id=8bc53ad6&scoped=true"
import script from "./ButtonOptions.vue?vue&type=script&lang=js"
export * from "./ButtonOptions.vue?vue&type=script&lang=js"
import style0 from "./ButtonOptions.vue?vue&type=style&index=0&id=8bc53ad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc53ad6",
  null
  
)

export default component.exports